import { Navigation, Pagination, Autoplay } from 'swiper'
import { SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { config } from './config'
import { StyledSwiper, Wrapper } from './styles'

export function Slider({
  children,
  navigationType = 'outside',
  autoPlayTime = 3000,
  loop = true,
}) {
  return (
    <Wrapper>
      <StyledSwiper
        $navigationType={navigationType}
        {...config}
        modules={[Navigation, Pagination, Autoplay]}
        autoplay={{
          delay: autoPlayTime,
          disableOnInteraction: false,
        }}
        navigation
        draggable
        loop={loop}
      >
        {children.map(child => (
          <SwiperSlide key={child.key}>{child}</SwiperSlide>
        ))}
      </StyledSwiper>
    </Wrapper>
  )
}
